import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  inMemoryPersistence,
  signInWithRedirect,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCCJ7rn3LFQykh8RgBrGTaAjOECVamilFY",
  authDomain: "slack-clone-16936.firebaseapp.com",
  projectId: "slack-clone-16936",
  storageBucket: "slack-clone-16936.appspot.com",
  messagingSenderId: "298295592009",
  appId: "1:298295592009:web:13622147bdda4a2057eb98",
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const auth = getAuth();

export const login = async () => {
  return setPersistence(auth, inMemoryPersistence)
    .then(() => {
      const provider = new GoogleAuthProvider();
      return signInWithRedirect(auth, provider);
    })
    .catch((err) => err);
};

export { db, auth };
